import { useUserMe } from './useUserMe';

export const useHasFeatureFlag = (flagKey: string): boolean => {
  const user = useUserMe().data;
  return (user.is_staff ?? false) || (user.feature_flags ?? []).includes(flagKey);
};
